// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsDetailBlock_newsBlock__feHnO {
  padding: 40px 0;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 135px);
  padding: 40px 0;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL {
  display: flex;
  justify-content: space-between;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx {
  padding: 0 20px;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx .NewsDetailBlock_titleBlock__\\+-CNm {
  font-size: 26px;
  font-weight: 500;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx .NewsDetailBlock_textBlock__h34vG {
  height: 400px;
  margin-top: 22px;
  padding-right: 10px;
  text-align: justify;
  overflow: auto;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC {
  padding: 0 20px;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC img {
  border-radius: 20px;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz {
  margin-top: 20px;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img:first-child {
  margin-right: 10px;
}
.NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img:last-child {
  margin-left: 10px;
}

@media (max-width: 991px) {
  .NewsDetailBlock_newsBlock__feHnO {
    padding: 40px 0 0 0;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL {
    flex-direction: column-reverse;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx {
    margin-top: 20px;
    padding: 0;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx .NewsDetailBlock_textBlock__h34vG {
    height: auto;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC {
    padding: 0;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 25px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz {
    margin-top: 14px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img {
    width: 100%;
    height: 180px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img:first-child {
    margin-right: 10px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img:last-child {
    margin-left: 10px;
  }
}
@media (max-width: 768px) {
  .NewsDetailBlock_newsBlock__feHnO {
    padding: 20px 0 0 0;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY {
    padding: 20px 0;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx {
    font-size: 14px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx .NewsDetailBlock_titleBlock__\\+-CNm {
    font-size: 18px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC {
    display: flex;
    flex-direction: column;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC img {
    height: 120px;
    border-radius: 20px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img {
    height: 70px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img:first-child {
    margin-right: 7px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_imagesBlock__YxJeC .NewsDetailBlock_imgFlexBlock__bVbIz img:last-child {
    margin-left: 7px;
  }
}
@media (max-width: 500px) {
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx {
    font-size: 12px;
  }
  .NewsDetailBlock_newsBlock__feHnO .NewsDetailBlock_root__m5UpY .NewsDetailBlock_wrapper__s3AdL .NewsDetailBlock_infoBlock__eKkPx .NewsDetailBlock_titleBlock__\\+-CNm {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NewsDetailBlock/NewsDetailBlock.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;AACJ;AACI;EACE,aAAA;EACA,8BAAA;AACN;AACM;EACE,eAAA;AACR;AACQ;EACE,eAAA;EACA,gBAAA;AACV;AAEQ;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAAV;AAIM;EACE,eAAA;AAFR;AAIQ;EACE,mBAAA;AAFV;AAKQ;EACE,gBAAA;AAHV;AAMY;EACE,kBAAA;AAJd;AAOY;EACE,iBAAA;AALd;;AAcA;EACE;IACE,mBAAA;EAXF;EAcI;IACE,8BAAA;EAZN;EAcM;IACE,gBAAA;IACA,UAAA;EAZR;EAcQ;IACE,YAAA;EAZV;EAgBM;IACE,UAAA;EAdR;EAgBQ;IACE,WAAA;IACA,aAAA;IACA,iBAAA;IACA,mBAAA;EAdV;EAiBQ;IACE,gBAAA;EAfV;EAiBU;IACE,WAAA;IACA,aAAA;EAfZ;EAiBY;IACE,kBAAA;EAfd;EAkBY;IACE,iBAAA;EAhBd;AACF;AAyBA;EACE;IACE,mBAAA;EAvBF;EAyBE;IACE,eAAA;EAvBJ;EA0BM;IACE,eAAA;EAxBR;EA0BQ;IACE,eAAA;EAxBV;EA4BM;IACE,aAAA;IACA,sBAAA;EA1BR;EA4BQ;IACE,aAAA;IACA,mBAAA;EA1BV;EA8BU;IACE,YAAA;EA5BZ;EA8BY;IACE,iBAAA;EA5Bd;EA+BY;IACE,gBAAA;EA7Bd;AACF;AAsCA;EAIQ;IACE,eAAA;EAvCR;EAyCQ;IACE,eAAA;EAvCV;AACF","sourcesContent":[".newsBlock {\n  padding: 40px 0;\n\n  .root {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: calc(100vh - 135px);\n    padding: 40px 0;\n\n    .wrapper {\n      display: flex;\n      justify-content: space-between;\n\n      .infoBlock {\n        padding: 0 20px;\n\n        .titleBlock {\n          font-size: 26px;\n          font-weight: 500;\n        }\n\n        .textBlock {\n          height: 400px;\n          margin-top: 22px;\n          padding-right: 10px;\n          text-align: justify;\n          overflow: auto;\n        }\n      }\n\n      .imagesBlock {\n        padding: 0 20px;\n\n        img {\n          border-radius: 20px;\n        }\n\n        .imgFlexBlock {\n          margin-top: 20px;\n\n          img {\n            &:first-child {\n              margin-right: 10px;\n            }\n\n            &:last-child {\n              margin-left: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 991px) {\n  .newsBlock {\n    padding: 40px 0 0 0;\n\n    .root {\n      .wrapper {\n        flex-direction: column-reverse;\n\n        .infoBlock {\n          margin-top: 20px;\n          padding: 0;\n\n          .textBlock {\n            height: auto;\n          }\n        }\n\n        .imagesBlock {\n          padding: 0;\n\n          img {\n            width: 100%;\n            height: 180px;\n            object-fit: cover;\n            border-radius: 25px;\n          }\n\n          .imgFlexBlock {\n            margin-top: 14px;\n\n            img {\n              width: 100%;\n              height: 180px;\n\n              &:first-child {\n                margin-right: 10px;\n              }\n\n              &:last-child {\n                margin-left: 10px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .newsBlock {\n    padding: 20px 0 0 0;\n\n    .root {\n      padding: 20px 0;\n\n      .wrapper {\n        .infoBlock {\n          font-size: 14px;\n\n          .titleBlock {\n            font-size: 18px;\n          }\n        }\n\n        .imagesBlock {\n          display: flex;\n          flex-direction: column;\n\n          img {\n            height: 120px;\n            border-radius: 20px;\n          }\n\n          .imgFlexBlock {\n            img {\n              height: 70px;\n\n              &:first-child {\n                margin-right: 7px;\n              }\n\n              &:last-child {\n                margin-left: 7px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .newsBlock {\n    .root {\n      .wrapper {\n        .infoBlock {\n          font-size: 12px;\n\n          .titleBlock {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newsBlock": `NewsDetailBlock_newsBlock__feHnO`,
	"root": `NewsDetailBlock_root__m5UpY`,
	"wrapper": `NewsDetailBlock_wrapper__s3AdL`,
	"infoBlock": `NewsDetailBlock_infoBlock__eKkPx`,
	"titleBlock": `NewsDetailBlock_titleBlock__+-CNm`,
	"textBlock": `NewsDetailBlock_textBlock__h34vG`,
	"imagesBlock": `NewsDetailBlock_imagesBlock__YxJeC`,
	"imgFlexBlock": `NewsDetailBlock_imgFlexBlock__bVbIz`
};
export default ___CSS_LOADER_EXPORT___;
